export default "__VITE_ASSET__BwOmA_2l__"